import PropTypes from "prop-types";

const DetailRow = ({ label, children }) => (
    <div className="flex items-center justify-between gap-3 py-2.5 text-sm">
        <dt className="text-muted">{label}</dt>
        <dd className="min-w-0 truncate text-right font-medium text-gray-900">{children}</dd>
    </div>
);

DetailRow.propTypes = {
    label   : PropTypes.string.isRequired,
    children: PropTypes.node
};

export default DetailRow;
